import { memo } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";

export const ProtectedRoute = memo(function ProtectedRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const isAuthenticated = useAuthStore((s) => s.token != null);
  const loading = useAuthStore((s) => s.loading);
  if (loading) {
    return (
      <div className="flex h-dvh lg:h-svh items-center justify-center">
        <div
          className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent"
          role="status"
          aria-label="Loading"
        />
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
});
